<template>
  <div class="company-system-joint" v-loading="loading">
    <div class="title">系统对接</div>
    <el-divider></el-divider>
    <div class="operation" v-for="(operation, index) in operations" :key="index">
      <div class="operation-wrap">
        <div class="introduce">
          <div class="item">{{ operation.label }}</div>
          <div style="font-size: 14px; color:#9e9e9e">{{ operation.detail }}</div>
        </div>
        <div class="action">
          <el-switch v-model="canSetting" @change="changeSetting"></el-switch>
          <span v-if="canSetting" class="setting" @click="goToJointSetting">设置</span>
        </div>
      </div>
      <el-divider></el-divider>
    </div>
  </div>
</template>
<script>
import { getCurCompany, updateDingConfig } from "@/api/userCenter/company"
export default {
  name: "company-system-joint",
  components: {},
  data() {
    return {
      operations: [
        {
          label: "钉钉",
          detail: "开启钉钉对接后，可同步钉钉组织架构、将消息发送至钉钉中"
        }
      ],
      loading: false,
      canSetting: false,
      currentCompany: {
        id: "",
        dingConfig: {},
        dingEnable: false
      }
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      getCurCompany().then(currentCompany => {
        this.currentCompany = currentCompany
        this.canSetting = this.currentCompany.dingEnable
      })
    },
    goToJointSetting() {
      this.$router.push({ name: "company-joint-setting" })
    },
    changeSetting(val) {
      this.currentCompany.dingEnable = val
      if (!val) {
        this.currentCompany.syncDing = false // 如果关闭钉钉对接，则自动关闭钉钉同步通讯录
      }
      updateDingConfig(this.currentCompany).then(() => this.$message.success("编辑成功"))
    }
  }
}
</script>
<style lang="scss" scoped>
.company-system-joint {
  .title {
    font-size: $font-size-title-first;
    margin-left: 20px;
  }
  .operation {
    width: 90%;
    margin: 30px 50px;
    .operation-wrap {
      padding-left: 10px;
      padding-right: 60px;
      display: flex;
      .introduce {
        flex: 1;
        .item {
          margin-bottom: 5px;
          font-weight: bold;
        }
      }
      .action {
        .setting {
          margin-left: 6px;
          font-size: 14px;
          color: #1989fa;
          cursor: pointer;
        }
      }
    }
  }
  ::v-deep {
    .el-divider--horizontal {
      margin: 10px 0;
    }
  }
}
</style>
